import { Box, Flex } from "@chakra-ui/react";
import { Resizable } from "re-resizable";
import { TaskInbox } from "../TaskInbox";
import { resizableHandleStyle, resizableStyles } from "../../utils/common/resizableStyles";
import { useIsMobileDevice } from "../../hooks/mobile/useIsMobileDevice";
import { DEFAULT_INBOX_WIDTH } from "../../constants/inbox/inbox";
import { MOBILE_VIEW_TYPE } from "../../types/main";
import { usePreference } from "../../hooks/preference/usePreference";

/**
 * @param {object} props
 * @param {boolean} props.hasBlocksSynchronizedWithGoogle - 백엔드가 보내는 block들과 Google Calendar 동기화 여부
 */
export function TaskInboxWithResizable({
  hasBlocksSynchronizedWithGoogle,
}: {
  hasBlocksSynchronizedWithGoogle: boolean;
}) {
  const { preference: userPreference, updatePreference } = usePreference();

  const mobileView = userPreference?.mobileView ?? MOBILE_VIEW_TYPE.INBOX;
  const savedInboxWidth = userPreference?.savedInboxWidth ?? DEFAULT_INBOX_WIDTH;
  const isMobileDevice = useIsMobileDevice();

  const handleUpdateInboxWidth = (width: number) => {
    updatePreference({ savedInboxWidth: width });
  };

  if (isMobileDevice) {
    return (
      <Box
        width="100%"
        height="100%"
        sx={resizableStyles}
        display={mobileView === "inbox" ? "block" : "none"}
      >
        <TaskInbox hasBlocksSynchronizedWithGoogle={hasBlocksSynchronizedWithGoogle} />
      </Box>
    );
  }

  return (
    <Flex
      sx={resizableStyles}
      height={"100%"}
      flexShrink={0}
    >
      <Resizable
        defaultSize={{
          width: savedInboxWidth,
          height: "100%",
        }}
        minWidth={250}
        maxWidth={1000}
        enable={{
          left: false,
          right: true,
          top: false,
          bottom: false,
          topRight: false,
          bottomRight: false,
          bottomLeft: false,
          topLeft: false,
        }}
        handleStyles={{
          right: resizableHandleStyle,
        }}
        handleClasses={{
          right: "custom-resizer-handle-right",
        }}
        onResizeStop={(e, direction, ref, d) => {
          if (ref?.offsetWidth) {
            handleUpdateInboxWidth(ref.offsetWidth);
          }
        }}
      >
        <TaskInbox hasBlocksSynchronizedWithGoogle={hasBlocksSynchronizedWithGoogle} />
      </Resizable>
    </Flex>
  );
}
